export const certs = [
    {
        name: 'C++ Associate Certification',
        date: 'Certified on Feb 4, 2019',
        description: 'Certificate of proficiency in C++ programming language.',
        link: 'https://github.com/mln-grg/OutscalBasicsUnity',
        pic: 'projectpictures/cpluscert.png',
    },
]